import { Component, ElementRef, HostListener, Injector, OnInit, ViewChild } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { AppAuthService } from '@shared/auth/app-auth.service';
import { NotificationServiceProxy } from '@shared/service-proxies/service-proxies';
import { NotificationCountUpdatedService } from "@shared/helpers/notification-count-updated.service";
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { ChangeDetectorRef, NgZone } from '@angular/core';

@Component({
  selector: 'app-right-menu',
  templateUrl: './right-menu.component.html',
  styleUrls: ['./right-menu.component.css']
})
export class RightMenuComponent extends AppComponentBase implements OnInit {
  numberNotifications: number = 0;
  notificationCountUpdatedService: NotificationCountUpdatedService;
  @ViewChild('popTemplate', { static: true }) popTemplate;
  @ViewChild('calendarPopover', { static: false }) calendarPopover: PopoverDirective;
  @ViewChild('notificationPopover', { static: false }) notificationPopover: PopoverDirective;
  @ViewChild('notificationIcon', { static: false }) notificationIcon: ElementRef;

  isPopoverOpen = false;
  tooltipsVisible: { [key: string]: boolean } = {};
  isToggling: boolean = false;

  constructor(injector: Injector,
    private _authService: AppAuthService,
    private _notificationService: NotificationServiceProxy,
    private cdr: ChangeDetectorRef,
    private zone: NgZone
  ) {
    super(injector);
    this.notificationCountUpdatedService = injector.get(NotificationCountUpdatedService);
  }

  ngOnInit() {
    this.notificationCountUpdatedService.notification.subscribe((x) => {
      this._notificationService.getUnreadNotificationsCount()
        .subscribe((result: number) => {
          this.numberNotifications = result;
        });
    });
  }

  toggleCalendar(dp: BsDatepickerDirective) {
    this.hideAllTooltips();
    dp.toggle();
  }

  showTooltip(key: string) {
    this.tooltipsVisible[key] = true;
  }

  hideTooltip(key: string) {
    this.tooltipsVisible[key] = false;
  }

  toggleTooltip(key: string) {
    this.tooltipsVisible[key] = !this.tooltipsVisible[key];
  }

  logout(): void {
    this.hideAllTooltips();
    abp.message.confirm(
      this.l('AreYouSureWantToLogout'),
      undefined,
      (result: boolean) => {
        if (result) {
          this._authService.logout();
        }
      }
    );
  }

  redirectUserConfiguration() {
    this.hideAllTooltips();
    this.router.navigate(['/app/settings/user-settings'])
  }

  togglePopover(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (!this.notificationPopover) return;

    if (this.isPopoverOpen) {
        this.closePopover();
    } else {
        this.openPopover();
    }
}

openPopover() {
    this.isPopoverOpen = true;
    this.notificationPopover.show();
}

closePopover() {
    this.isPopoverOpen = false;
    this.notificationPopover.hide();
}


  hideAllTooltips() {
    this.tooltipsVisible = {
      calendar: false,
      notifications: false,
      userPreferences: false,
      logout: false
    };
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    if (this.notificationIcon) {
      const clickedInsideIcon = this.notificationIcon.nativeElement.contains(targetElement);
      const popoverContainer = document.querySelector('.popover.show');

      if (!clickedInsideIcon && popoverContainer && !popoverContainer.contains(targetElement)) {
        this.notificationPopover.hide();
        this.isPopoverOpen = false;
      }
    }
  }

  onClosePopover(): void {
    this.notificationPopover.hide();
    this.isPopoverOpen = false;
  }
}
